import axios from '@/api/config';

const classInfoPhase = {
  getLastPhase (data) {
    return axios.get(`${process.env.BASE_URL}/classInfoPhase/getLastPhase`, { params: data })
  },
  getClassInfoPhaseTree (data) {
    return axios.get(`${process.env.BASE_URL}/classInfoPhase/getClassInfoPhaseTree`, { params: data })
  },
  addClassInfoPhase (data) {
    return axios.post(`${process.env.BASE_URL}/classInfoPhase/addClassInfoPhase`, data)
  },
  updateClassInfoPhase (data) {
    return axios.put(`${process.env.BASE_URL}/classInfoPhase/updateClassInfoPhase`, data)
  },
  // deleteClassInfoPhase (data) {
  //   return axios.delete(`${process.env.BASE_URL}/classInfoPhase/deleteClassInfoPhase`, { data: data })
  // },
  pageList (data) {
    return axios.post(`${process.env.BASE_URL}/classInfoPhase/pageList`, data)
  },
  getClassInfoPhaseDetail (data) {
    return axios.get(`${process.env.BASE_URL}/classInfoPhase/getClassInfoPhaseDetail`, { params: data })
  },
  getClassInfoPhaseList (data) {
    return axios.get(`${process.env.BASE_URL}/classInfoPhase/getClassInfoPhaseList`, { params: data })
  },
  // 删除
  deleteClass (data) {
    return axios.delete(`${process.env.BASE_URL}/classInfoPhase/deleteClassInfoPhase`, { data: data })
  },
}
export default classInfoPhase



// WEBPACK FOOTER //
// ./src/api/classInfoPhase.js